import { NumPair, Point, Vector2 } from "../Misc/Utils";

export module VectorOps{
    export function vector2(a: Point, b: Point): Vector2{
        return [b[0]-a[0], b[1]-a[1]];
    }

    export function magnitude(v: Vector2): number{
        return Math.sqrt(v[0]*v[0]+v[1]*v[1]);
    }

    export function unit(v: Vector2): Vector2{
        var mag = magnitude(v);
        return [v[0]/mag, v[1]/mag];
    }

    export function multiply(n: number, v: Vector2): Vector2{
        return [n*v[0], n*v[1]];
    }

    export function opposite(v: Vector2): Vector2{
        return multiply(-1, v);
    }

    export function dot(v: Vector2, u: Vector2): number{
        return v[0]*u[0]+v[1]*u[1];
    }

    export function perpendicularClockwise(v: Vector2): Vector2{
        return [v[1], -v[0]];
    }

    export function perpendicularCounterClockwise(v: Vector2): Vector2{
        return [-v[1], v[0]];
    }
}